module.exports = __webpack_public_path__ + "img/MGH-Gion-6-2440x1172.ef319433.jpg";